module.exports = __webpack_public_path__ + "static/media/icon-vision.f4884d79.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/icon-vision.svg
// module id = 568
// module chunks = 0